import { CustomInput, ReactSelect, CheckInput } from "../kits/Inputs/Inputs";
import ColorSchema from "../kits/Color";
import { useState, useEffect, useMemo } from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { translateToReactSelect } from "../../utils/helperFunction";
import ToastCustomize from "../kits/ToastCustomize";
import useAxios from "../../services/useAxios";
import { TrashIcon } from "../kits/Icons";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { Card, Accordion, Form } from "react-bootstrap";
import CustomButton from "../kits/button/CustomButton";
import "./AddAndEdit.scss";

export default function OrderItems({
  type = "order",
  priceType,
  itemIndex,
  data,
  product,
  optionShow,
  setOptionShow,
  setProduct,
  // option,
  // setOption,
  optionProduct,
  getProductFun,
  getProduct,
  customerVal,
  setCustomerVal,
  fabrics,
  changeHandlerFullInfo,
  currentOrderType,
  id,
  checkOptionHandler,
}) {
  const productPieces = [
    { value: 1, label: "یک" },
    { value: 2, label: "دو" },
    { value: 3, label: "سه" },
  ];
  const productPiecesConfig = [
    {
      productPiecesId: 1,
      datas: [
        {
          id: "p1_fabric_id",
          title: "پارچه",
          array: fabrics,
          type: "select",
          value: "",
        },
      ],
    },
    {
      productPiecesId: 2,
      datas: [
        {
          id: "p1_fabric_id",
          title: "پارچه‌بالا",
          array: fabrics,
          type: "select",
          value: "",
        },
        {
          id: "p1_height",
          title: "قد‌بالا",
          type: "input",
          value: "",
        },
        {
          id: "p2_fabric_id",
          title: "پارچه‌پایین",
          array: fabrics,
          type: "select",
          value: "",
        },
      ],
    },
    {
      productPiecesId: 3,
      datas: [
        {
          id: "p1_fabric_id",
          title: "پارچه‌بالا",
          array: fabrics,
          type: "select",
          value: "",
        },
        {
          id: "p1_height",
          title: "قد‌بالا",
          type: "input",
          value: "",
        },
        {
          id: "p2_fabric_id",
          title: "پارچه‌وسط",
          array: fabrics,
          type: "select",
          value: "",
        },
        {
          id: "p2_height",
          title: "قد‌وسط",
          type: "input",
          value: "",
        },
        {
          id: "p3_fabric_id",
          title: "پارچه‌پایین",
          array: fabrics,
          type: "select",
          value: "",
        },
      ],
    },
  ];
  // usexios
  const { execute: checkAvbProductForOrderAPI } = useAxios(
    "api/check_avb_product_for_order"
  );

  //state
  const [inputValue, setInputValue] = useState({
    product: { price: 0 },
    count: 0,
    price: 0,
    discount: 0,
    totalPrice: 0,
    options: [],
  });

  const [newState, setNewState] = useState([]);
  const [errorTxt, setErrorTxt] = useState({ discount: "" });
  const [option, setOption] = useState([]);

  const prductList = useMemo(
    () =>
      +currentOrderType === 1
        ? product?.filter((p) => +p.main_type === 2 || p.main_type === 5)
        : product,
    [product, currentOrderType]
  );

  // func
  const changeHandlerInputValue = (object, index) => {
    setInputValue((prev) => {
      return { ...prev, ...object };
    });
  };
  const errorHandler = (object) => {
    setErrorTxt((prev) => {
      return { ...prev, ...object };
    });
  };
  function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      console.log("totally custom!")
    );
    console.log("product", product);
    return (
      <button
        type="button"
        style={{
          // backgroundColor:
          // defaultKey == activeKey ? ColorSchema.white : ColorSchema.blue_5,
          width: 24,
          height: 24,
          border: "none",
          borderRadius: 4,
        }}
        onClick={decoratedOnClick}
        className="mr-l-20 d-flex align-items-center"
      >
        {children}
      </button>
    );
  }

  function checkPriceHandler(event) {
    event.preventDefault();

    let sendData = {
      ps_id: data?.product?.value,
      ps_height: data.height,
      ps_width: data.width,
      ps_gramaj: data.garamaj,
    };

    data?.piecesData?.[0]?.datas?.forEach(
      (val) => (sendData[val.id] = val.value)
    );

    if (
      Object.keys(sendData).some(
        (k) => sendData[k] === undefined || sendData[k] === ""
      )
    ) {
      ToastCustomize({
        mainText: "اطلاعات وارد شده ناقص است.",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      return;
    }

    if (
      sendData.p1_height !== undefined && // if p1_height exist(2 fabric_id)
      (+sendData.p1_height >= +sendData.ps_height || // if fabric 1's height was taller than or equal to(no room for fabric 2's height) the whole height
        (sendData.p2_height !== undefined && // if p2_height exist(3 fabric_id)
          +sendData.p1_height + +sendData.p2_height >= +sendData.ps_height)) // if sum of fabric 1's height and fabric 2's height was taller than or equal to(no room for fabric 3's height) the whole height
    ) {
      ToastCustomize({
        mainText: "قد‌های وارد شده با هم همخوانی ندارند.",
        duration: 2000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
      return;
    }

    checkAvbProductForOrderAPI(sendData)
      .then((res) => {
        if (+res.status === 1) {
          changeHandlerFullInfo(
            {
              price: +res.avb_product_for_order.price,
              discount: 0,
              apfo_id: res.avb_product_for_order.id,
              totalPrice: +res.avb_product_for_order.price * data.count,
              isChecked: true,
            },
            "item",
            id
          );
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در استعلام قیمت پیش آمده است.",
            duration: 3000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
          throw new Error(res);
        }
      })
      .catch((err) => console.log(err));
  }

  console.log("test", data);
  return (
    <div
      className={`d-flex flex-wrap mt-3 ${
        type == "order" && "mx-4"
      } pb-3 pt-2 position-relative order-items-style`}
      style={{
        // backgroundColor: ColorSchema.secondary_light_custom,
        borderRadius: "12px",
        border: `1px solid ${ColorSchema.primary_custom}`,
      }}
    >
      <div className="position-absolute d-flex w-100" style={{ top: -15 }}>
        {type == "order" && (
          <div
            className="ms-auto"
            onClick={() => {
              changeHandlerFullInfo({}, "remove", id);
            }}
          >
            <TrashIcon
              containerIconClassName=" p-1 cursor-pointer"
              color={ColorSchema.white_custom}
              style={{
                backgroundColor: ColorSchema.danger_custom,
                borderRadius: "50%",
                width: 28,
                height: 28,
              }}
            />
          </div>
        )}
      </div>
      <div
        className="box-group width1
      
      "
        // col-6 col-sm-4 col-lg-3
      >
        <div className="box-inp">
          <ReactSelect
            itemsList={prductList}
            // inputValue={filterIdToObject(
            //   inputValue.product,
            //   filterData.business_id
            // )}
            // inputValue={inputValue.product}
            inputValue={data.product}
            onChangeFunc={(e) => {
              console.log("product", e);
              setOption(e.product_options);
              setOptionShow(e.order_options);
              // changeHandlerInputValue({ product: e, count: 0, discount: 0 });
              // changeHandlerFullInfo({ product: e, count: 0, discount: 0 }, "item", id);
              errorHandler({ discount: "" });
              if (+currentOrderType === 2) {
                changeHandlerInputValue({ product: e, count: 0 });
                changeHandlerFullInfo({ product: e, count: 0 }, "item", id);
              } else {
                changeHandlerInputValue({
                  product: e,
                  count: 0,
                  discount: 0,
                  price: e.price,
                });
                changeHandlerFullInfo(
                  { product: e, count: 0, discount: 0, price: e.price },
                  "item",
                  id
                );
              }
            }}
            title="محصول "
            inputSize="text"
            type="text"
            inputContainer=""
          />
        </div>
      </div>
      {/* col-6 col-sm-4 col-lg-1 */}
      <div className="box-group width3">
        <div className="box-inp">
          <CustomInput
            id="titleTour"
            label="تعداد"
            inputSize="text"
            type="text"
            inputContainer=""
            // inputValue={inputValue.count}
            inputValue={data.count}
            onChangeFunc={(e) => {
              // changeHandlerInputValue({ count: e.target.value, discount: 0 });
              if (!isNaN(e.target.value)) {
                changeHandlerInputValue({ count: e.target.value });
                errorHandler({
                  discount: "",
                });
                changeHandlerFullInfo(
                  {
                    count: e.target.value,
                  },
                  "item",
                  id
                );
              }
            }}
          />
        </div>
      </div>
      {/* col-6 col-sm-4 col-lg-1 */}
      <div className="box-group width2">
        <div className="box-inp">
          <CustomInput
            id="titleTour"
            label="قیمت(تومان)"
            inputSize="text"
            type="text"
            activate="disabled"
            inputContainer=""
            // inputValue={addCommas(inputValue.product.price)}
            inputValue={addCommas(data.price)}
            // onChangeFunc={(e) => {
            //   changeHandlerInputValue({ price: e.target.value });
            //   changeHandlerFullInfo(
            //     { price: removeCommas(e.target.value) },

            //     "item",
            //     id
            //   );
            // }}
          />
        </div>
      </div>
      {/* col-6 col-sm-4 col-lg-1 */}
      <div className="box-group width2">
        <div className="box-inp">
          <CustomInput
            id="titleTour"
            label="تخفیف(تومان)"
            inputSize="text"
            type="text"
            activate={data.isChecked ? "active" : "disabled"}
            inputContainer=""
            // inputValue={addCommas(inputValue.discount)}
            inputValue={addCommas(data.discount)}
            onChangeFunc={(e) => {
              if (+removeCommas(e.target.value) <= data.price * data.count) {
                changeHandlerInputValue({ discount: e.target.value });
                changeHandlerFullInfo(
                  { discount: removeCommas(e.target.value) },

                  "item",
                  id
                );
                errorHandler({ discount: "" });
              } else {
                errorHandler({
                  discount: "مقدار تخفیف نباید بیشتر از مقدار قیمت کل باشد.",
                });
                changeHandlerFullInfo(
                  { discount: removeCommas(e.target.value) },
                  "item",
                  id
                );
              }
            }}
            textErr={errorTxt.discount}
          />
        </div>
      </div>
      {/* col-6 col-sm-4 col-lg-1 */}
      <div className="box-group width2">
        <div className="box-inp">
          <CustomInput
            label="قیمت‌کل(تومان)"
            inputSize="text"
            type="text"
            activate="disabled"
            inputContainer=""
            // inputValue={inputValue.totalPrice}
            // inputValue={addCommas(
            //   (inputValue.product.price - inputValue.discount) *
            //     inputValue.count
            // )}
            inputValue={addCommas(data.price * data.count - data.discount)}
            onChangeFunc={(e) => {
              changeHandlerInputValue({ totalPrice: e.target.value });
              changeHandlerFullInfo({ totalPrice: e.target.value }, "item", id);
            }}
          />
        </div>
      </div>
      {
        // (data?.product?.product_structure_id == 1 ||
        //   data?.product?.product_structure_id == 2 ||
        //   data?.product?.product_structure_id == 3) && (
        (data?.product?.product_structure_id == 1 ||
          data?.product?.product_structure_id == 2 ||
          data?.product?.product_structure_id == 3) && (
          <>
            {/* {" "}col-6 col-sm-4 col-lg-1 */}
            <div className="box-group width3">
              <div className="box-inp">
                <CustomInput
                  label="قد"
                  inputSize="text"
                  type="text"
                  inputContainer=""
                  inputValue={data.height}
                  // inputValue={inputValue.totalPrice}
                  // inputValue={addCommas(
                  //   (inputValue.product.price - inputValue.discount) *
                  //     inputValue.count
                  // )}
                  // inputValue={addCommas(
                  //   data.product.price * data.count - data.discount
                  // )}
                  onChangeFunc={(e) => {
                    changeHandlerFullInfo(
                      { height: e.target.value },
                      "item",
                      id
                    );
                  }}
                />
              </div>
            </div>
            {/* col-6 col-sm-4 col-lg-1 */}
            <div className="box-group width3">
              <div className="box-inp">
                <CustomInput
                  label="کف"
                  inputSize="text"
                  type="text"
                  inputContainer=""
                  inputValue={data.width}
                  onChangeFunc={(e) => {
                    changeHandlerFullInfo(
                      { width: e.target.value },
                      "item",
                      id
                    );
                  }}
                />
              </div>
            </div>
            {/* col-6 col-sm-4 col-lg-2 */}
            {data?.product.product_structure_id == 2 && (
              // data?.product?.value == 2
              <div className="box-group width3">
                <div className="box-inp">
                  <CustomInput
                    label="عطف"
                    inputSize="text"
                    type="text"
                    inputContainer=""
                    activate="disabled"
                    inputValue="10"
                  />
                </div>
              </div>
            )}
            {/* col-6 col-sm-4 col-lg-1 */}
            <div className="box-group width3">
              <div className="box-inp">
                <CustomInput
                  label="گرماژ"
                  inputSize="text"
                  type="text"
                  inputContainer=""
                  inputValue={data.garamaj}
                  onChangeFunc={(e) => {
                    changeHandlerFullInfo(
                      { garamaj: e.target.value },
                      "item",
                      id
                    );
                  }}
                />
              </div>
            </div>
            {+currentOrderType === 2 && (
              // col-6 col-sm-4 col-lg-1
              <div className="box-group width2">
                <div className="box-inp">
                  <ReactSelect
                    itemsList={productPieces}
                    // inputValue={filterIdToObject(
                    //   inputValue.product,
                    //   filterData.business_id
                    // )}
                    // inputValue={inputValue.product}
                    inputValue={data.pieces}
                    onChangeFunc={(e) => {
                      changeHandlerInputValue({ pieces: e });
                      changeHandlerFullInfo({ pieces: e }, "item", id);
                      // console.log("value*** dd", productPiecesConfig, e);
                      changeHandlerFullInfo(
                        {
                          piecesData: productPiecesConfig.filter(
                            (value) => value.productPiecesId == e.value
                          ),
                        },
                        "item",
                        id
                      );
                    }}
                    title="تکه "
                    inputSize="text"
                    type="text"
                    inputContainer=""
                  />
                </div>
              </div>
            )}
          </>
        )
      }
      {console.log("debug", data)}
      {data?.piecesData != undefined &&
        data?.piecesData[0]?.datas?.map((value) => {
          // console.log("value*** 000", data);
          return (
            // col-6 col-sm-4 col-lg-2
            <div
              className={`box-group ${
                value.type == "select" ? "width1" : "width3"
              }`}
            >
              {value.type == "select" ? (
                <ReactSelect
                  itemsList={value.array}
                  inputValue={
                    value.value !== "" &&
                    value.array?.find((val) => val.value == value.value)
                  }
                  onChangeFunc={(e) => {
                    checkOptionHandler(
                      "fabricOptions",
                      data.id,
                      value.id,
                      value.type,
                      e
                    );
                  }}
                  title={value.title}
                  inputSize="text"
                  type="text"
                  inputContainer=""
                />
              ) : (
                <CustomInput
                  id="titleTour"
                  label={value.title}
                  inputSize="text"
                  type="text"
                  inputContainer=""
                  inputValue={value.value}
                  onChangeFunc={(e) => {
                    checkOptionHandler(
                      "fabricOptions",
                      data.id,
                      value.id,
                      value.type,
                      e
                    );
                  }}
                  // textErr={errorTxt.discount}
                />
              )}
            </div>
          );
        })}
      {data?.product?.product_options?.length > 0 && (
        <>
          {data?.product?.product_options?.map((value, index) => {
            console.log("debug t** value", value?.selected);
            return (
              <div className="box-group col-6 col-sm-4 col-lg-2">
                <div className="box-inp">
                  <ReactSelect
                    id="titleTour"
                    title={value[0]?.title}
                    // title="اپشن محصول"
                    inputSize="text"
                    type="text"
                    inputContainer=""
                    itemsList={translateToReactSelect(
                      false,
                      value.value,
                      "value"
                    )}
                    // inputValue={data.options}
                    inputValue={value.selected}
                    onChangeFunc={(e) => {
                      changeHandlerInputValue({ options: e }, index);

                      checkOptionHandler(
                        "productOption",
                        data.id,
                        value[0]?.id,
                        e.value,
                        e
                      );
                    }}
                  />
                </div>
              </div>
            );
          })}
        </>
      )}
      {+currentOrderType === 2 && data?.product?.product_structure_id != 4 && (
        <div className="d-flex justify-content-end mt-3 align-items-center ms-auto me-3">
          <CustomButton
            className=""
            onClick={checkPriceHandler}
            color="primary"
          >
            استعلام قیمت
          </CustomButton>
        </div>
      )}

      {data.product?.order_options?.length > 0 && type == "order" && (
        <div className="my-3 w-100 border-top mx-3">
          {/* <p style={{ fontWeight: "bold", listStyle: "circle" }}>
          {data.product?.label}
        </p> */}
          <div className="px-3 pt-3">
            {" "}
            {data.product?.order_options?.map((optionValue, optionIndex) => {
              return (
                <div className="d-flex flex-wrap">
                  <h5 className="fw-bold">{optionValue[0]?.title}:</h5>
                  &nbsp; &nbsp;
                  {/* <CheckInput
                              key={`corporate-customer-1`}
                              label={"عدم انتخاب"}
                              type="radio"
                              id={`corporate-radio-1-${itemIndex}-${optionIndex}-${-10}`}
                              name={`corporate-radio-${itemIndex}-${optionIndex}`}
                              // inputValue={recipient.CheckInput}
                              // inputValue={d.value?.checked}
                              onChangeFunc={() =>
                                checkOptionHandler(
                                  "orderOption",
                                  value.id,
                                  optionValue[0]?.id,
                                  -10
                                )
                              }
                            /> */}
                  {optionValue?.value?.map((d, oValueIndex) => {
                    return (
                      <div className="d-flex flex-wrap align-items-center mx-1">
                        {" "}
                        <CheckInput
                          key={`corporate-customer-1`}
                          label={d.value?.name}
                          type="radio"
                          id={`corporate-radio-1-${itemIndex}-${optionIndex}-${oValueIndex}`}
                          name={`corporate-radio-${itemIndex}-${optionIndex}`}
                          // inputValue={recipient.CheckInput}
                          inputValue={d.value?.checked}
                          onChangeFunc={() =>
                            checkOptionHandler(
                              "orderOption",
                              data.id,
                              optionValue[0]?.id,
                              d.id
                            )
                          }
                        />
                        &nbsp;&nbsp; (
                        <span style={{ fontSize: 13 }}>
                          {/* تاثیر در قیمت واحد(
                        {
                          priceType.filter((p) => p.value == d.value?.unit)?.[0]
                            ?.label
                        }
                        ): */}
                          {addCommas(
                            parseInt(d.value?.pricePerUnit) *
                              parseInt(data.count) +
                              d.value?.priceOnOrder
                          )}
                          &nbsp; + &nbsp;&nbsp; تومان
                        </span>
                        {/* <span style={{ fontSize: 13 }}>
                        تاثیر قیمت کل(تومان): {addCommas(d.value?.priceOnOrder)}
                      </span> */}
                        )
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {/* {currentOrderType == 1 && (
        <Accordion defaultActiveKey={0}>
          <div>
            <div
              className="d-flex align-items-center border-top font-12 "
              style={{
                // backgroundColor:
                // defaultKey == activeKey
                //   ? ColorSchema.blue_5
                //   : ColorSchema.white,
                height: 56,
              }}
            >
              {" "}
              <CustomToggle>
                {" "}
                <Form.Check type={"checkbox"} id={`default-exact`} name="d" />
              </CustomToggle>
              قیمت خرید تغییر کند؟
            </div>
            <Accordion.Collapse
              // eventKey={defaultKey}
              style={{ backgroundColor: ColorSchema.white }}
            >
              <div className="mr-x-40 pd-y-8 ">
                <div key={`default-price`} className="mb-3">
                  <Form.Check
                    type={"radio"}
                    id={`default-exact`}
                    label={`اعمال روی کالاهای مشابه `}
                    name="w"
                  />
                </div>
                <div key={`default-price`} className="mb-3">
                  <Form.Check
                    type={"radio"}
                    id={`default-similar`}
                    label={`اعمال روی دقیقا این کالا`}
                    name="w"
                  />
                </div>
              </div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      )} */}
    </div>
  );
}
